import { isLocalHost } from "shared/util/EnvironmentHelpers";

function getDevjailUrl() {
	return isLocalHost
		? `https://${process.env.DEVJAIL_USERNAME}.dev.okcupid.com`
		: `https://${window.location.host}`;
}

export default getDevjailUrl;



// WEBPACK FOOTER //
// ./src/shared/util/getDevjailUrl.js